// extracted by mini-css-extract-plugin
module.exports = {"tnc-wrapper":"_30aspZVr5SHxwA9xg77LsN","header-ol":"_2E_A-Dyu8hn_9U64sw30KR"};